import { ref, remove } from 'firebase/database';
import { database } from '../firebase';

export const removeSpecificPersonFromSession: (
    personId: string,
    sessionId: string,
) => Promise<void> = async (personId, sessionId) => {
    try {
        await remove(ref(database, `sessions/${sessionId}/people/${personId}`));
    } catch (err) {
        throw err;
    }

    return;
};
